import { render, staticRenderFns } from "./TireStats.vue?vue&type=template&id=a80823ea"
import script from "./TireStats.vue?vue&type=script&lang=ts"
export * from "./TireStats.vue?vue&type=script&lang=ts"
import style0 from "./TireStats.vue?vue&type=style&index=0&id=a80823ea&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports